import { useStripe } from '@stripe/react-stripe-js';
import { CanMakePaymentResult } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { getBrand } from 'state/brand';
import { getOrdersTotalInclTaxWithDiscount } from 'state/orders';
import { useAppSelector } from 'state/store';

export const useStripeEligibility = () => {
    const stripe = useStripe();
    const brand = useAppSelector(getBrand);
    const totalInclTaxWithDiscount = useAppSelector(getOrdersTotalInclTaxWithDiscount);

    const [eligibility, setEligibility] = useState<CanMakePaymentResult | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true);

            if (!stripe || !brand || !window.PaymentRequest) {
                setEligibility(null);
                setLoading(false);
                return;
            }

            const pr = stripe.paymentRequest({
                country: 'FR',
                currency: brand.currency.toLowerCase(),
                total: {
                    label: brand.name,
                    amount: totalInclTaxWithDiscount,
                },
            });

            const result = await pr.canMakePayment();
            setEligibility(result);
            setLoading(false);
        })();
    }, [stripe, brand, totalInclTaxWithDiscount]);

    return {
        isStripeLoading: loading,
        stripeEligibility: eligibility,
    };
};
